import axios from "axios";
import { API } from "../../backend";
import authHeader from "../auth-header";

// source: "template" | "contract"; q matches description or contract number
const searchCopySource = (source, contract_type, q) => {
  return axios.get(API + "contracts/copy-search/", {
    params: { source, contract_type, q },
    headers: authHeader(),
  });
};

const copyContract = (source_contract_id, contract_type) => {
  return axios.post(
    API + "contracts/copy-contract/",
    { source_contract_id, contract_type },
    { headers: authHeader() }
  );
};

const setTemplate = (id, is_template) => {
  return axios.post(
    API + "contracts/contract-template/" + id + "/",
    { is_template },
    { headers: authHeader() }
  );
};

const TemplateCopyService = {
  searchCopySource,
  copyContract,
  setTemplate,
};
export default TemplateCopyService;
